import NewAndSeenHeader from './NewAndSeenHeader'

export default NewAndSeenHeader
